import script from "./EmojiSelectTabIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojiSelectTabIcon.vue?vue&type=script&setup=true&lang=ts"

import "./EmojiSelectTabIcon.vue?vue&type=style&index=0&id=7e2a724c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2a724c"]])

export default __exports__